module.exports = __webpack_public_path__ + "static/img/部件组成3-SDC300.c50f446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type2-2/部件组成3-SDC300.png
// module id = y3ja
// module chunks = 0